import * as Actions from '../adm-accounts-clients.actions'
import { IDS } from '../adm-accounts-clients-action-id.constants';
import { TYPES } from '../adm-accounts-clients-action-type.constants';

/**
 * @const {object}
 * @memberOf module:Administration
 */
export const admAccountsClientDetails = {
    /* @ngInject */
    controller: function ($ngRedux, $state, $mdDialog, $rootScope, NavigationService, Notifier, SubjectTypesService) {
        /**
         * @function $onInit
         */
        this.title = 'Account Details';
        this.$onInit = () => {
            const navConfig = NavigationService.getConfig($state.$current);
            this.colorName = navConfig.colorName;
            this.icon = navConfig.icon;

            SubjectTypesService.fetchSubjectTypes(
                null,
                null, //containerId,
                0, //onlyDirect,
                'hof'
            ).then(data => {
                $ngRedux.dispatch({
                    type: TYPES.FETCH_ROLE_OPTIONS,
                    id: IDS.admAccountsClients,
                    path: 'hofRoleOptions',
                    data: data.map(item => ({
                        label: item.name,
                        value: item.id
                    }))
                });
            });


            SubjectTypesService.fetchSubjectTypes(
                null,
                null, //containerId,
                0, //onlyDirect,
                'slo'
            ).then(data => {
                $ngRedux.dispatch({
                    type: TYPES.FETCH_ROLE_OPTIONS,
                    id: IDS.admAccountsClients,
                    path: 'sloRoleOptions',
                    data: data.map(item => ({
                        label: item.name,
                        value: item.id
                    })).sort((a, b) => a.label.localeCompare(b.label)),
                });
            });

            this.unsubscribe = $ngRedux.connect(({administration}) => {
                const cli = administration.admAccountsClients;
                return {
                    clientDetails: cli.admAccountsClientDetails,
                    newExternalJobTitle: cli.newExternalJobTitle,
                    newExternalId: cli.newExternalId,
                    selectedNewRole: cli.selectedNewRole,
                }
            }, Actions)(this);

            this.fetchOutsourcedManagementProviderOptions();
            this.fetchSiteCapabilities();
        }
        this.addNewRole = (event) => {
            this.addExternalRole({
                client_uuid:        this.clientDetails.client_uuid,
                sty_id:             this.selectedNewRole,
                external_job_title: this.newExternalJobTitle,
                external_uuid:      this.newExternalId
            });
        }

        this.onInactivateRole = ({item}) => {
            this.inactivateExternalRole({s2e_id: item.id});
        }

        this.submit = (event) => {
            if (!this.accountsClientDetailsForm.$valid) {
                Notifier.error('Please fill all required fields in the form!');
                return;
            }
            this.updateAccountsClientDetails(this.clientDetails);
        }

        this.$onDestroy = () => {
            this.unsubscribe();
        };
    },
    template: `
    <tabs-header title="{{$ctrl.title}}"></tabs-header>
    <div layout="column" flex>
        <form id="accountsClientDetailsForm" name="$ctrl.accountsClientDetailsForm" novalidate>
            <fieldset>
                <div layout-gt-sm="row">
                    <input-text flex
                                name="cliName" identifier="admAccountsClients"
                                label="Client Name"
                                model="$ctrl.clientDetails.name"
                                state-path="admAccountsClientDetails.name"
                                validate="true">
                    </input-text>
                    <input-select flex
                        name="newClientAccountOutsourcedManagementProvider"
                        identifier="admAccountsClients"
                        state-path="admAccountsClientDetails.outsourced_management_provider"
                        state-data="outsourcedManagementProviderOptions"
                        label="Outsourced Management Provider"
                        preselect="true">
                    </input-select>
                </div>
                <div layout-gt-sm="row">
                    <input-select-multiple flex
                        identifier="admAccountsClients"
                        label="Site Capabilities"
                        name="admAccountsClientSiteCapabilities"
                        state-path="admAccountsClientDetails.site_capabilities"
                        state-data="siteCapabilitiesOptions">
                    </input-select-multiple>
                    <input-text flex name="businessNumber" identifier="admAccountsClients"
                                label="Business Number"
                                model="$ctrl.clientDetails.business_number"
                                state-path="admAccountsClientDetails.business_number">
                    </input-text>
                    <input-text flex name="corporationNumber" identifier="admAccountsClients"
                                label="Corporation Number"
                                model="$ctrl.clientDetails.corporation_number"
                                state-path="admAccountsClientDetails.corporation_number">
                    </input-text>
                </div>
                
                <input-checkbox label="Two-Factor Authentication Enabled"
                                identifier="admAccountsClients"
                                model="$ctrl.clientDetails.enable_2fa"
                                state-path="admAccountsClientDetails.enable_2fa">
                </input-checkbox>
                
                <md-divider style="padding:40px"></md-divider>
                
                <h4 class="colorAdministration">Single Sign On</h4>
                
                <div layout-gt-sm="row">
                    <input-text flex
                                name="tenantId" identifier="admAccountsClients"
                                label="Tenant ID"
                                model="$ctrl.clientDetails.tenant_uuid"
                                state-path="admAccountsClientDetails.tenant_uuid"
                                validate="UUID">
                    </input-text>
                    <input-text flex name="tenantAppId" identifier="admAccountsClients"
                                label="Tenant App ID"
                                model="$ctrl.clientDetails.tenant_app_uuid"
                                state-path="admAccountsClientDetails.tenant_app_uuid"
                                validate="UUID">
                    </input-text>
                </div>
                
                <div layout-gt-sm="row">
                    <input-text flex
                                name="corporateGroupId" identifier="admAccountsClients"
                                label="Corporate Managers Group ID"
                                model="$ctrl.clientDetails.corporate_man_group_uuid"
                                state-path="admAccountsClientDetails.corporate_man_group_uuid"
                                validate="UUID">
                    </input-text>
                    <div flex></div>
                </div>
                
                <input-checkbox label="Single Sign On Enabled"
                                identifier="admAccountsClients"
                                state-path="admAccountsClientDetails.sso_enabled">
                </input-checkbox>
        
        
            </fieldset>
        </form>
        
        <adm-accounts-client-external-roles-grid
            on-remove="$ctrl.onInactivateRole($event)">
        </adm-accounts-client-external-roles-grid>
        
        <form id="accountsClientNewRoleForm" name="$ctrl.accountsClientNewRoleForm" novalidate>
            <div layout-gt-sm="row" layout-align="center">
                <md-subheader class="md-no-sticky" style="margin-top: 20px">Add Role</md-subheader>
                <asset cls="input-icon" style="margin-top: 15px" src="search.svg"></asset>
                <input-select
                        flex-gt-sm="20"
                        label="New Role Level"
                        identifier="admAccountsClients"
                        state-path="selectedNewRoleLevel"
                        state-data="newRoleLevelOptions"
                        select-first-item="true"
                        preselect="true"
                        on-change="$ctrl.onRoleLevelSelect($event)">
                </input-select>
                <input-select
                        flex-gt-sm="20"
                        label="New Role"
                        identifier="admAccountsClients"
                        state-path="selectedNewRole"
                        state-data="newRoleOptions"
                        preselect="true"
                        on-change="$ctrl.onRoleSelect($event)">
                </input-select>
                <input-text flex
                            name="newExternalJobTitle" identifier="admAccountsClients"
                            label="New External Job Title"
                            model="$ctrl.newExternalJobTitle"
                            state-path="newExternalJobTitle"
                            max-length="255"
                            validate="true">
                </input-text>
                <input-text flex
                            name="newExternalId" identifier="admAccountsClients"
                            label="New External ID"
                            model="$ctrl.newExternalId"
                            state-path="newExternalId"
                            validate="UUID">
                </input-text>
                <md-button class="btnColorAdministration"
                    ng-click="$ctrl.addNewRole()">Add New Role</md-button>              
            </div>
        </form>
        <md-divider style="padding:40px"></md-divider>
    </div>
    <tabs-navigation identifier="app.administration.accounts"
         state="app.administration.accounts.clientDetails"
         state-prop="$ctrl.client.uuid"
         on-exec="$ctrl.submit($event)">
    </tabs-navigation>
`
}
;
